// extracted by mini-css-extract-plugin
export default {"heroImg":"CampaignDraftGate_heroImg__82yMG","container":"CampaignDraftGate_container__l9tqa"};